export default defineNuxtRouteMiddleware(async () => {
  await useMainStore().fetch()
})
